function headerSubmenu() {

    if ( (window.innerWidth || document.documentElement.clientWidth) < 979) {
        
        document.addEventListener("click", function(event) { // Detect all clicks on the document
            
             // If user clicks inside any of these elements, do nothing
            if (event.target.closest(".header-submenu")) return;
            if (event.target.closest(".menu-items")) return;
            closeHeaderMenus(); // If user clicks outside the element, hide it!
        });
    }

    var headerSubmenuCloses = document.querySelectorAll(".menu-close");
    headerSubmenuCloses.forEach(function(headerSubmenuClose){
        
        headerSubmenuClose.onclick = function() {closeHeaderMenus()}
    });

    var headerSubmenuItems = document.querySelectorAll(".has-submenu");
    headerSubmenuItems.forEach(function(headerSubmenuItem){
    if ( (window.innerWidth || document.documentElement.clientWidth) < 979) {
        headerSubmenuItem.onclick = function(headeritem) {toggleHeaderMenu(headeritem)}
    } else {
        headerSubmenuItem.onmouseover = function(headeritem) {toggleHeaderMenu(headeritem, true)}
        headerSubmenuItem.onmouseout = function() {startCloseMenu()}
    }
    });

    var headerSubmenus = document.querySelectorAll(".header-submenu");
    headerSubmenus.forEach(function(headerSubmenu){
    headerSubmenu.onmouseover = function() {cancelMenuTimeout()}
    headerSubmenu.onmouseout = function() {startCloseMenu()}
    });

    // Close menu function
    var closeHeaderMenus = function (){
        var headerSubmenus = document.querySelectorAll(".header-submenu");
        headerSubmenus.forEach(function(headerSubmenu){
            headerSubmenu.classList.remove("is-open");
        });
    }

    // Open menu function
    var toggleHeaderMenu = function (headeritem, forceopen = false){

    var headerSubmenu = document.querySelector("#"+headeritem.srcElement.id+"-submenu");  
    if (headerSubmenu.classList.contains("is-open") && !forceopen) {
        closeHeaderMenus();
    } else {
        closeHeaderMenus();
        cancelMenuTimeout();
        headerSubmenu.classList.add("is-open");
    }
    }

    // Close menu function on TIMEOUT
    var headerCloseTimeout = false;
    var startCloseMenu = function (){
    cancelMenuTimeout();
    headerCloseTimeout = setTimeout(function(){closeHeaderMenus()}, 1000);
    }
    // Cancel closemenu TIMEOUT
    var cancelMenuTimeout = function (){
    clearTimeout(headerCloseTimeout);
    }


    /********************************* Mobile menu burger *********************************/

    var burger = document.querySelector("#header-burger");
    if (burger) {
        burger.onclick = function(e) {
            closeHeaderMenus();
            var submenu = document.querySelector(".menu-items");
            // submenu.classList.toggle("is-open");
            submenu.classList.contains("is-open")
                ? submenu.classList.remove("is-open")
                : submenu.classList.add("is-open");
            e.preventDefault();
        }
    }

}

export default headerSubmenu;